import { render, staticRenderFns } from "./Admins.vue?vue&type=template&id=47f8c09e&scoped=true"
import script from "./Admins.vue?vue&type=script&lang=js"
export * from "./Admins.vue?vue&type=script&lang=js"
import style0 from "./Admins.vue?vue&type=style&index=0&id=47f8c09e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f8c09e",
  null
  
)

export default component.exports